var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._b({staticClass:"icon"},'svg',_vm.$attrs,false),[_c('use',{attrs:{"xlink:href":_vm.xLink}})])}
var staticRenderFns = []

export { render, staticRenderFns }